import { isNumber, orderBy } from "lodash"

export const dataSortByYOrder = (
  dataConverted: any[],
  yAxisOrder: any[],
  widgetGroupBy: any[]
): any[] => {
  if (isNumber(yAxisOrder?.[0])) {
    return yAxisOrder?.map(order => {
      return dataConverted?.[order]
    })
  } else {
    return orderByString(widgetGroupBy, dataConverted, yAxisOrder)
  }
}

export const flattenObject = (obj: any): any =>
  Object.keys(obj).reduce((acc: any, k) => {
    if (typeof obj[k] === "object" && obj[k] !== null && !Array.isArray(obj[k]))
      Object.assign(acc, obj[k])
    else acc[k] = obj[k]
    return acc
  }, {})

export const orderByString = (category: any[], data: any[], keys: any[]): any[] => {
  return orderBy(data, [
    item => {
      return keys.indexOf(item?.[category?.[0]?.valueId])
    },
  ])
}

/**
 * Index de la série visible la plus haute d'une pile, pour un point de données donné.
 *
 * Sert à n'afficher le total d'une colonne empilée qu'UNE fois, au sommet. Le bullet est posé
 * sur toutes les séries puis effacé partout sauf sur celle-ci : le poser sur la seule dernière
 * série ferait disparaître le total dès que l'utilisateur masque cette série depuis la légende.
 *
 * @param row         la ligne de données (dataContext du point amCharts)
 * @param valueFields les champs de valeur, dans l'ordre d'empilement
 * @param isHidden    la série d'index j est-elle masquée (légende) ?
 * @returns l'index de la série la plus haute portant une valeur, ou -1 si la pile est vide
 */
export const findTopVisibleStackIndex = (
  row: Record<string, unknown> | undefined,
  valueFields: string[],
  isHidden: (index: number) => boolean
): number => {
  if (!row) return -1

  let topmostIndex = -1
  for (let j = 0; j < valueFields.length; j++) {
    if (isHidden(j)) continue
    const value = Number(row[valueFields[j]])
    if (Number.isFinite(value) && value !== 0) topmostIndex = j
  }
  return topmostIndex
}
